import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CanonicalService } from './common/services/canonical.service';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  host: { ngSkipHydration: 'true' },
  imports: [
    RouterOutlet
  ],
})
export class AppComponent {

  constructor(@Inject(PLATFORM_ID) private platformId: any,
    private canonicalService: CanonicalService,
    private route: ActivatedRoute,
    private router: Router) {

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route),
      map((route) => {

        while (route.firstChild) route = route.firstChild;
        return route;

      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event: any) => {

        if (isPlatformBrowser(this.platformId)) {
          gtag('config', 'G-7B0KB5W4HM', {
            page_path: event.urlAfterRedirects
          });
        }

        this.canonicalService.UpdateEvent(event);
        this.canonicalService.setCanonicalURL();

      });

  }

  title = 'Runeterra AR';

}
